// extracted by mini-css-extract-plugin
export var chip = "_qi-2";
export var chipBody = "_qi-8";
export var chipHeader = "_qi-9";
export var chipWithKind = "_qi-7";
export var icon = "_qi-3";
export var kind = "_qi-a";
export var remove = "_qi-5";
export var removeIcon = "_qi-6";
export var row = "_qi-0";
export var rowHistorical = "_qi-1";
export var text = "_qi-4";